import { createSlice } from "@reduxjs/toolkit";
import { FilterStateStoreEmail } from "./types";

const INITIAL_STATE: FilterStateStoreEmail = {
  filters: {
    search: "",
    date: undefined,
    conciliation_date_range: undefined,
    store_code: undefined,
    analyst: undefined,
    status: undefined,
    justification_id: undefined,
    type: undefined,
    payroll_voucher_status: undefined,
    dataType: "divergence",
    order: {},
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const manageLossFilterSlice = createSlice({
  name: "manageLossFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setManageLossFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetManageLossFilters(state) {
      state.filters = {
        ...INITIAL_STATE.filters,
        dataType: state.filters.dataType,
        date: state.filters.date,
      };
    },
    switchDataType(state, action) {
      const newDataType = action.payload;
      // Mantém filtros comuns que funcionam em ambos os modos
      state.filters = {
        ...INITIAL_STATE.filters,
        dataType: newDataType,
        date: state.filters.date,
        conciliation_date_range: state.filters.conciliation_date_range,
        store_code: state.filters.store_code,
        analyst: state.filters.analyst,
        status: state.filters.status,
        type: state.filters.type,
        search: state.filters.search,
        meta: { page: 1, perPage: state.filters.meta?.perPage || 10 },
      };
    },
  },
});

export const { setManageLossFilter, resetManageLossFilters, switchDataType } = manageLossFilterSlice.actions;
export default manageLossFilterSlice.reducer;
